// Displays records based on tickets, cars,license plates and dates range
import React, { useState, useRef, useEffect } from 'react';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from '../css/searchPage.module.css';
import { serverURL } from '../helpers/dataServerURL';
import { FaArrowLeft } from 'react-icons/fa6';
import { fetchSearchResults } from '../helpers/reportsDataAPI';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import ActivitiesRptUpdated from '../components/ActivitiesRptUpdated';

function SearchPage() {
  const inputRef = useRef(null);
  const [searchItem, setSearchItem] = useState('');
  const [searchData, setSearchData] = useState([]);
  const [hasSearch, setHasSearch] = useState(false);

  const navigate = useNavigate();

  const logInURL = serverURL.server.url;

  useEffect(() => {
    inputRef.current.focus();
  });
  const isEmpty = Array.isArray(searchData) && searchData.length === 0;
  const hasResults = Array.isArray(searchData) && searchData.length > 0;

  return (
    <div className={styles.topContainer}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Slide}
      />

      <div className={styles.mainContainer}>
        <div>
          <label style={{ color: 'white', marginRight: '10px', fontSize: '16px' }}>Search:</label>
          <input
            className={styles.searchInput}
            ref={inputRef}
            value={searchItem}
            placeholder="Search..."
            onChange={(e) => {
              setSearchItem(e.target.value);
            }}
            onKeyDown={async (e) => {
              if (e.key === 'Enter') {
                if (!searchItem.trim()) return;

                const result = await fetchSearchResults(logInURL, searchItem);
                setSearchData(result);
                setHasSearch(true);
              }
            }}
          />
          <FaSearch
            className={styles.searchIcon}
            size={24}
            color="blue"
            onClick={async () => {
              if (!searchItem.trim()) return;

              const result = await fetchSearchResults(logInURL, searchItem);
              setSearchData(result);
              setHasSearch(true);
            }}
          />
        </div>
        <div>
          <a
            href="##"
            className={styles.backButton}
            onClick={() => {
              navigate('/');
            }}
          >
            <FaArrowLeft
              size={28}
              className={styles.backIcon}
              onClick={() => {
                navigate('/');
              }}
            />
            Back Home
          </a>
        </div>
      </div>

      {hasSearch && isEmpty && (
        <h2>No data found. Change your search keywords or narrow your search and try again.</h2>
      )}

      {hasSearch && hasResults && (
        <>
          <h2 className={styles.title}>Search Results for "{searchItem}"</h2>
          <ActivitiesRptUpdated reportData={searchData} />
        </>
      )}
    </div>
  );
}

export default SearchPage;
